(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multiple-images-with-text"] && !Shopify.designMode) return;
  try {
    
class MultipleImagesWithTextTabs extends HTMLElement {
  connectedCallback() {
    const parent = this.parentElement;
    if (!parent) return;

    this._contentCarousel = parent.querySelector('multiple-images-with-text-content-list');
    this._imageCarousel = parent.querySelector('multiple-images-with-text-image-list');
    this._sectionEl = parent.querySelector('multiple-images-with-text');
    if (!this._contentCarousel) return;

    this._tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this._items = Array.from(this._contentCarousel.children);

    this._tabs.forEach((tab, index) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        this._goTo(index);
      });
      tab.addEventListener('keydown', (event) => this._onKeydown(event, index));
    });

    this._observer = new MutationObserver(() => this._syncTabs());
    this._items.forEach((item) => {
      this._observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });

    this._syncTabs();
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();
  }

  _currentIndex() {
    const idx = this._items.findIndex((item) => item.classList.contains('is-selected'));
    return idx === -1 ? 0 : idx;
  }

  _goTo(targetIndex) {
    if (targetIndex < 0 || targetIndex >= this._items.length) return;
    const current = this._currentIndex();
    if (current === targetIndex) return;

    const callSelect = (carousel, idx) => {
      if (!carousel) return false;
      if (typeof carousel.select === 'function') {
        carousel.select(idx);
        return true;
      }
      return false;
    };

    const contentOk = callSelect(this._contentCarousel, targetIndex);

    let imageIndex = targetIndex;
    if (this._imageCarousel) {
      const targetItem = this._items[targetIndex];
      const imageId = targetItem ? targetItem.getAttribute('image-id') : null;
      if (imageId && this._imageCarousel.items) {
        const found = Array.from(this._imageCarousel.items).findIndex((item) => item.id === imageId);
        if (found !== -1) imageIndex = found;
      }
      callSelect(this._imageCarousel, imageIndex);
    }

    if (!contentOk && this._sectionEl) {
      const eventName = targetIndex > current ? 'control:next' : 'control:prev';
      const steps = Math.abs(targetIndex - current);
      for (let i = 0; i < steps; i++) {
        this._sectionEl.dispatchEvent(new CustomEvent(eventName, { bubbles: false }));
      }
    }
  }

  _onKeydown(event, index) {
    const last = this._tabs.length - 1;
    let next = null;
    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        next = index === last ? 0 : index + 1;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        next = index === 0 ? last : index - 1;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = last;
        break;
      default:
        return;
    }
    event.preventDefault();
    this._goTo(next);
    if (this._tabs[next]) this._tabs[next].focus();
  }

  _syncTabs() {
    const current = this._currentIndex();
    this._tabs.forEach((tab, index) => {
      const active = index === current;
      tab.classList.toggle('is-selected', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });
  }
}

if (!customElements.get('multiple-images-with-text-tabs')) {
  customElements.define('multiple-images-with-text-tabs', MultipleImagesWithTextTabs);
}

  } catch(e) { console.error(e); }
})();
})();
